import React, { FC, useCallback } from 'react';
import OWTaskComponent from './OWTaskComponent';
import { doNothingPromise } from '../../thunks/fetch_utils';

const OWTaskFormComponent: FC<any> = ({ value, onChange }): React.ReactElement => {
	const onTasksChange = useCallback(
		(tasks) => {
			const sanitizedTasks = (tasks || []).filter((_) => !!_.title);
			onChange(
				sanitizedTasks.map((task, orderingId) => ({
					title: task.title,
					questionType: task.questionType,
					groupTitle: task.groupTitle,
					orderingId,
					siteSurveyTemplateIds: task.siteSurveyTemplateIds || undefined,
				}))
			);
		},
		[onChange]
	);

	return (
		<OWTaskComponent
			existingTasks={value}
			isAllowedToEdit
			bulkUpdateTasks={doNothingPromise}
			bulkDeleteTasks={doNothingPromise}
			onTaskEdit={doNothingPromise}
			onTaskDelete={doNothingPromise}
			timezonId={null}
			onTasksChange={onTasksChange}
			notCheckable
			isPMTemplate
		/>
	);
};

export default OWTaskFormComponent;
